import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'bc-registration-complete-dialog',
  templateUrl: './registration-complete-dialog.component.html',
  styleUrls: ['./registration-complete-dialog.component.scss'],
  standalone: false,
})
export class RegistrationCompleteDialogComponent {
  constructor(public dialogRef: MatDialogRef<RegistrationCompleteDialogComponent>) {
    dialogRef.disableClose = true;
  }

  accept(): void {
    window.location.href = '/account/location/default/store';
    this.dialogRef.close();
  }
}
